import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Import styles
import "./index.css";
import "./styles.css";

// Import @one styles, web components, and fonts
import "@one/web-components/dist/owc/owc.css";
import "@one/icons/dist/one-icons-outlined.css";
import "@one/icons/dist/one-icons-filled.css";
import "@one/roche-font/roche-font.css";
import "@one/design-tokens/css/regular/navify/light/variables.css";
import "@one/web-components";
import { setTheme } from "@one/web-components";

// Set the theme to regular_navify_light
setTheme("regular_navify_light");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
